import { ToggleButtonGroup } from '@mui/material';
import { FC } from 'react';

interface Props {
  className?: string;
  value: any;
  /**
   * If true, only allow one of the child ToggleButton values to be selected.
   */
  exclusive?: boolean;
  onChange?: (event: React.MouseEvent<HTMLElement>, value: any) => void;
  children: React.ReactNode;
  fullWidth?: boolean;
  disabled?: boolean;
}

export const QcsToggleButtonGroup: FC<Props> = ({ className, value, exclusive = true, onChange, children, fullWidth, disabled }) => {
  return (
    <ToggleButtonGroup disabled={disabled} className={className} value={value} exclusive={exclusive} onChange={onChange} fullWidth={fullWidth}>
      {children}
    </ToggleButtonGroup>
  );
};
